import {
  CLOSE_SIDEBAR_MENU,
  OPEN_SIDEBAR_MENU,
} from "../actions/sideBarMenuActions";
const sideBarMenuReducer = (state = "open", action) => {
  if (action.type === OPEN_SIDEBAR_MENU) {
    return "open";
  } else if (action.type === CLOSE_SIDEBAR_MENU) {
    return "close";
  }
  return state;
};
export default sideBarMenuReducer;
